// Augusta University's undergraduate majors (#2652). Read on 2026-10-01 from
// the official 2026-2027 Augusta University Catalog, Programs sorted by
// college (catalog.augusta.edu, catoid=50, navoid=5988): every line under a
// college's "Bachelor's" heading. The catalog lists each concentration as its
// own program, so they are kept as listed; the degree prefix ("Bachelor of
// Arts in ...") is shown as the degree. Left out: the four tracks not open
// to first-year applicants (Accelerated BSN, RN to BSN, Dental Hygiene degree
// completion, Clinical Laboratory Science for certified MLTs/CLTs and the
// military), minors, certificates and graduate programs. Flags quote the
// Apply to Augusta University page (the college file's `apply` source).
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "augusta-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in Augusta University's official 2026-2027 Catalog, grouped by the college that offers it, as the catalog lists each concentration. Minors, certificates, graduate programs and degree-completion tracks for working professionals are left out.",
    "groups": [
        {
            "name": "College of Allied Health Sciences",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                },
                {
                    "name": "Health Information Administration",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                },
                {
                    "name": "Health Services",
                    "degree": "BS"
                },
                {
                    "name": "Health Services and a Concentration in Pre-Speech Language Pathology",
                    "degree": "BS"
                },
                {
                    "name": "Radiologic Sciences in Nuclear Medicine Technology",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                },
                {
                    "name": "Radiologic Sciences in Radiation Therapy",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                },
                {
                    "name": "Respiratory Therapy",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                }
            ]
        },
        {
            "name": "Katherine Reese Pamplin College of Arts, Humanities, and Social Sciences",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "English and a Concentration in Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English and a Concentration in Literature",
                    "degree": "BA"
                },
                {
                    "name": "English and a Concentration in Professional Writing and Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "English and a Secondary Teacher Certification",
                    "degree": "BA"
                },
                {
                    "name": "Health, Society, and Policy",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and a Concentration in Public History",
                    "degree": "BA"
                },
                {
                    "name": "History and a Secondary Teacher Certification",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music and an Emphasis in Music Industry Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and a Secondary Teacher Certification",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art and a Concentration in Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Art and a Concentration in Drawing/Painting",
                    "degree": "BFA"
                },
                {
                    "name": "Art and a Concentration in Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Art and a Concentration in Printmaking/Photography",
                    "degree": "BFA"
                },
                {
                    "name": "Art and a Concentration in Sculpture/Ceramics",
                    "degree": "BFA"
                },
                {
                    "name": "Digital and Visual Storytelling",
                    "degree": "BFA"
                },
                {
                    "name": "Music Education and a Concentration in Instrumental",
                    "degree": "BM"
                },
                {
                    "name": "Music Education and a Concentration in Vocal",
                    "degree": "BM"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "James M. Hull College of Business",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BBA"
                },
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Business Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Corporate Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Digital Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Financial Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Financial Planning and Counseling",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Healthcare Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Hospitality Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Human Resources Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Investments",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Management",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Professional Sales",
                    "degree": "BBA"
                },
                {
                    "name": "Business Administration with a Concentration in Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "School of Computer and Cyber Sciences",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Biomedical Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cyber Operations",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology with a Concentration in Business",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Dental College of Georgia",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS",
                    "flag": "A separate application: this program is one of Augusta's capacity-limited allied health programs.",
                    "flagSource": "apply"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Sports Management",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Special Education (eMajor USG Consortium)",
                    "degree": "BS in Education"
                },
                {
                    "name": "Kinesiology with a Concentration in Exercise and Sports Science",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a Concentration in Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a Concentration in Medical Professions",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a Concentration in Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology with a Concentration in Pre-Physical Therapy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN",
                    "flag": "A separate application through NursingCAS.",
                    "flagSource": "apply"
                }
            ]
        },
        {
            "name": "College of Science and Mathematics",
            "source": {
                "label": "Augusta University Catalog 2026-2027, Programs by College",
                "url": "https://catalog.augusta.edu/content.php?catoid=50&navoid=5988"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology and a Concentration in Ecology",
                    "degree": "BS"
                },
                {
                    "name": "Cell and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and a Concentration in Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and a Concentration in Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and a Concentration in Medicinal Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and a Concentration in Nuclear Science",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry and a Concentration in Professional Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and a Concentration in Biostatistics or Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and a Secondary Teacher Certification",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics and a Concentration in Nuclear Science",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
